import React from 'react';
import useUniqueId from 'hooks/useUniqueId';
import Modal from 'components/Modal';
import { getIsActiveTabFromParams } from 'utils/content/getIsActiveTabFromParams';
import { getTabLinkFromParams } from 'utils/content/getTabLinkFromParams';
import SingleAssetManager from './SingleAssetManager';
import MultiAssetManager from './MultiAssetManager';
function AssetManager(_ref) {
  var inContentManagerContext = _ref.inContentManagerContext,
    hasOpenOption = _ref.hasOpenOption,
    assets = _ref.assets,
    parentPlaylist = _ref.parentPlaylist,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var titleId = useUniqueId();
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    layout: "top-aligned",
    width: "extraWide"
  }, assets.length === 1 ? /*#__PURE__*/React.createElement(SingleAssetManager, {
    inContentManagerContext: inContentManagerContext,
    hasOpenOption: hasOpenOption,
    titleId: titleId,
    asset: assets[0],
    parentPlaylist: parentPlaylist,
    onClose: onClose,
    onSubmit: onSubmit,
    getIsActiveTab: getIsActiveTabFromParams,
    getTabLink: getTabLinkFromParams
  }) : /*#__PURE__*/React.createElement(MultiAssetManager, {
    titleId: titleId,
    assets: assets,
    parentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
    onClose: onClose,
    onSubmit: onSubmit,
    getIsActiveTab: getIsActiveTabFromParams,
    getTabLink: getTabLinkFromParams
  }));
}
export default AssetManager;
export { ShareMultiContentOption } from './MultiAssetManager/MultiAssetHeader';
export { useGetTabInfo } from './useGetTabInfo';